// import APIs
import { updateDutyLine } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';

// import types
import { UpdateDutyLineParams } from './useUpdateDutyLine.types';

const useUpdateDutyLine = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: UpdateDutyLineParams) => updateDutyLine(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useUpdateDutyLine;
